import { render } from "./DisplayDetails.vue?vue&type=template&id=bc016fe4&scoped=true"
import script from "./DisplayDetails.vue?vue&type=script&lang=js"
export * from "./DisplayDetails.vue?vue&type=script&lang=js"

import "./DisplayDetails.vue?vue&type=style&index=0&id=bc016fe4&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc016fe4"]])

export default __exports__